export const environment = {
	production: true,
	payPalSandboxClientId: 'ATPq0V4yc0_urA4ClSw9mN1vbL0jI6heWym7Cw2dmnNsnltfdfkRWX6WbBKkpqJ_Gi8myywiW2r4Rfcy',
	payPalProdClientId: 'AaDV7OzTWSCE51DQXRmVGs2jfz1gep6L8oCvwQbyYevq3zHkfiKcAYKaYD4LYj_VcW_8dV6nNO5nkYa0',
	stripePKTest: 'pk_test_41SVSiIEMin8o0FSb7HfAezNofDVQlOlXpJRWwQKeOxvTKJuchONTlQ1xL0Vc0Zjl5N2fGv6o8HnmHHuboqYqtSnJ00YUwAndry',
	stripePKProd: 'pk_live_41SVSiIEMin8o0FSb7HfASGTLOgRqQbEGsC6SWLc9ag3c4zuH3jWqtj40pV3lyAa4O7De3Hv5UQeHhQjggWHr5w8000HVyknWj5',
	urlOverride: false,
};
